import {
  SelectedDate,
  TIMEFRAME_CONFIG,
  ACTIVE_PERIOD_TO_PREFIX,
  type TimeframePrefix,
} from '../SelectedDate'

/**
 * Helper function to determine if a record name is for a calendar note
 */
export function isCalendarNoteRecordName(recordName: string): boolean {
  const parts = recordName.split('_')
  const prefix = parts[0] as TimeframePrefix
  return prefix in TIMEFRAME_CONFIG
}

/**
 * Parses a calendar note record name into timeframe and teamspace
 */
export function parseCalendarNoteRecordName(recordName: string) {
  const parts = recordName.split('_')
  const timeframePrefix = parts[0] as TimeframePrefix
  const teamspaceId = parts[1]
  const targetTimeframe = TIMEFRAME_CONFIG[timeframePrefix]

  return { timeframePrefix, teamspaceId, targetTimeframe }
}

/**
 * Derives record name from selectedDate for calendar notes
 */
export function deriveCalendarRecordName(selectedDate: SelectedDate): string {
  const prefix = ACTIVE_PERIOD_TO_PREFIX[selectedDate.activePeriod]
  return selectedDate.teamspace ? `${prefix}_${selectedDate.teamspace}` : prefix
}
